<template>
  <div class="thread-form-group">
    <div v-if="$slots.label || $scopedSlots.label || label" class="thread-form-group__label">
      <slot name="label">
        <label :for="inputId">
          <thread-text type="label">{{ label }}</thread-text>
        </label>
      </slot>
    </div>
    <slot />
    <div v-if="$slots.helperText || $scopedSlots.helperText || helperText" class="thread-form-group__helper-text">
      <slot name="helperTextIcon">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M14.6667 8.00065C14.6667 11.6827 11.682 14.6673 8.00004 14.6673C4.31804 14.6673 1.33337 11.6827 1.33337 8.00065C1.33337 4.31865 4.31804 1.33398 8.00004 1.33398C11.682 1.33398 14.6667 4.31865 14.6667 8.00065ZM8.00004 11.834C8.13265 11.834 8.25983 11.7813 8.35359 11.6875C8.44736 11.5938 8.50004 11.4666 8.50004 11.334V7.33398C8.50004 7.20138 8.44736 7.0742 8.35359 6.98043C8.25983 6.88666 8.13265 6.83398 8.00004 6.83398C7.86743 6.83398 7.74026 6.88666 7.64649 6.98043C7.55272 7.0742 7.50004 7.20138 7.50004 7.33398V11.334C7.50004 11.61 7.72404 11.834 8.00004 11.834ZM8.00004 4.66732C8.17685 4.66732 8.34642 4.73756 8.47144 4.86258C8.59647 4.9876 8.66671 5.15717 8.66671 5.33398C8.66671 5.5108 8.59647 5.68036 8.47144 5.80539C8.34642 5.93041 8.17685 6.00065 8.00004 6.00065C7.82323 6.00065 7.65366 5.93041 7.52864 5.80539C7.40361 5.68036 7.33337 5.5108 7.33337 5.33398C7.33337 5.15717 7.40361 4.9876 7.52864 4.86258C7.65366 4.73756 7.82323 4.66732 8.00004 4.66732Z"
            fill="#637381"
          />
        </svg>
        <thread-text type="caption">{{ helperText }}</thread-text>
      </slot>
    </div>
  </div>
</template>

<script>
import ThreadText from "@/components/common/thread-text.vue";

export default {
  name: "ThreadFormGroup",
  components: { ThreadText },
  props: {
    label: {
      type: String,
      default: ""
    },
    inputId: {
      type: String,
      default: ""
    },
    helperText: {
      type: String,
      default: ""
    }
  }
};
</script>

<style scoped lang="scss">
.thread-form-group {
  margin-bottom: 12px;

  &__label {
    display: block;
  }

  &__helper-text {
    display: flex;
    align-items: center;
    gap: 4px;
    padding-top: 8px;
    padding-left: 12px;
  }
}
</style>
